module.exports = __webpack_public_path__ + "static/media/cert_20200201.7d7e4a20.jpg";